import { Distributor } from '@larvitu/shared/react/components/feature-distributor';

import type { DistributorProps } from '@larvitu/shared/react/components/feature-distributor';
import type { LoadingButtonProps } from '@mui/lab';
import type { FC } from 'react';
import type { ControllerProps } from 'react-hook-form';

export interface MuiLoadingButtonAdapterProps
  extends Omit<LoadingButtonProps, 'children'>, Partial<Parameters<ControllerProps['render']>[0]>
{
  children: DistributorProps<
    LoadingButtonProps // & Omit<Parameters<ControllerProps['render']>[0], 'formState'>
  >['children'];
}
// export type MuiLoadingButtonAdapterProps =
//   & Omit<LoadingButtonProps, 'children'>
//   & Partial<Parameters<ControllerProps['render']>[0]>
//   & DistributorProps<
//     LoadingButtonProps // & Omit<Parameters<ControllerProps['render']>[0], 'formState'>
//   >;

export const MuiLoadingButtonAdapter: FC<MuiLoadingButtonAdapterProps> = ({
  formState,
  children,
  ...props
}) => // console.log( formState?.errors );
(
  <Distributor
    {...props}
    {...Object.keys( formState?.errors ?? {} ).length > 0 ? { color: 'error' } : {}}
    loading={formState?.isSubmitting}
  >
    {children}
  </Distributor>
);
